import * as React from "react";
import { Spinner } from "react-bootstrap";

export default function LoadingOverlay() {
  return (<div className="loading-overlay"><Spinner animation="border" variant="light" /></div>)
}
